import React, { useEffect, useState } from 'react';
import WorkShopViewDetails from '../../common/workshop/WorkShopViewDetails';
import { useLocation } from 'react-router-dom';
import CoachLayout from '../../../layouts/CoachLayout';
import MenuLayout from '../../../layouts/MenuLayout';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWorkshopeDetailsById } from '../../../redux/features/coach/actions/coachAction';
import Loader from '../../../components/loader';

const CoachWorkShopDetails = () => {
    const { state } = useLocation();
    const dispatch = useDispatch();
    const { isLoading2, workshopDetail } = useSelector((state) => state.coach.coach);
    const [workShopData, setWorkShopData] = useState({
        data: {}
    });
    const user = { name: "Workshop", role: "coach" };
    const location = window?.location?.search?.split("=")[1];

    useEffect(() => {
        let data =
            workshopDetail && Object.keys(workshopDetail).length > 0
                ? workshopDetail
                : state?.data;
        setWorkShopData(prev => ({
            ...prev,
            data: data
        }));
    }, [workshopDetail]);

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(fetchWorkshopeDetailsById({ payload: location }));
    }, []);

    if (isLoading2) {
        return <Loader />
    };
    return (
        <MenuLayout user={user}>
            <WorkShopViewDetails state={workShopData} />
        </MenuLayout>
    )
};

export default CoachWorkShopDetails;